<template>
    <!-- SECTION-FUNCTIONS -->
    <div id="section-functions" class="col-12 p-0">
        <div class="container">
            <router-link to="/" v-if="!screen" class="fa fa-2x fa-times d-lg-flex"></router-link>
            <div class="row m-0">
                <div class="col-10 offset-2 col-lg-8 px-0 d-flex flex-column justify-content-end my-3">
                    <h4>Funcionalidades</h4>
                    <p>Algumas das principais funcionalidades do sistema</p>
                </div>
            </div>
            <div class="row justify-content-center my-3">
                <div v-for="funcoes in funcionalidades" :key="funcoes.id"
                    class="col-10 col-md-5 col-lg-3 card py-5 m-3">
                    <span class="bord">
                        <img v-if="funcoes.img" :src="require(`@/assets/login/icons/${funcoes.img}`)" alt="">
                        <i v-else :class="funcoes.icon" class="fa fa-3x text-secondary"></i>
                    </span>
                    <p class="titulo m-0">{{ funcoes.titulo }}</p>
                    <!-- <hr class="m-0" />
                    <p class="m-0">{{ funcoes.mensagem }}</p> -->
                </div>
            </div>
            <div class="row align-items-center justify-content-between w-100 mx-auto my-5 py-3 callout-x alert-dark">
                <div class="d-none d-lg-block col-md-2 text-right"><i class="fa fa-3x fa-file-text-o"></i></div>
                <div class="col-12 col-md px-0">
                    <p class="text-lg text-center my-lg-0">Agender uma demonstração</p>
                </div>
                <div class="col-12 col-md-3 text-center">
                    <router-link to="/contato" class="btn btn-primary">Agende agora</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['screen'],
        data() {
            return {
                funcionalidades: [{
                        img: 'gestao.png',
                        titulo: 'Gestão de usuários',
                        mensagem: 'Gerenciar seus usuários e seus níveis de acesso dentro da empresa.',
                    },
                    {
                        img: 'simplesotimizado.png',
                        titulo: 'Simples e otimizado',
                        mensagem: 'Os contratos são assinados rapidamente e de forma simples em um navegador web.',
                    },
                    {
                        img: 'preco.png',
                        titulo: 'Preço simples e fixo',
                        mensagem: 'Nosso modelo de precificação pré-pago ajudará seu negócio a se organizar e crescer.',
                    },
                    {
                        img: 'privacidade.png',
                        titulo: 'Privacidade',
                        mensagem: 'Você tem confiabilidade ao enviar contratos para seus clientes. Não vendemos ou trocamos nenhuma informação.',
                    },
                    {
                        img: 'API.png',
                        titulo: 'Integração API',
                        mensagem: 'Nunca foi tão fácil integrar com uma plataforma de assinatura online.',
                    },
                    {
                        img: 'email.png',
                        titulo: 'Envio em massa',
                        mensagem: 'Monte  a lista de signatários e envie em massa os contratos com facilidade.',
                    },
                    {
                        icon: 'fa-pencil-square-o',
                        titulo: 'Assinatura Personalizada',
                        mensagem: 'Assinatura por extenso e rubrica.',
                    },
                    {
                        icon: 'fa-lock',
                        titulo: 'Validação em duas etapas',
                        mensagem: 'Validação de assinatura por SMS.',
                    },
                    {
                        icon: 'fa-area-chart',
                        titulo: 'Dashboard',
                        mensagem: 'Dashboard com status das assinaturas e controles de consumo.',
                    },
                    {
                        icon: 'fa-line-chart',
                        titulo: 'Timeline',
                        mensagem: 'Timeline, lembretes e status das assinaturas.',
                    },
                    {
                        icon: 'fa-refresh',
                        titulo: 'Workflow',
                        mensagem: 'Workflow dos Signatários.',
                    },
                    {
                        icon: 'fa-thumbs-o-down',
                        titulo: 'Recusa com Justificativa',
                        mensagem: 'Opção de recusa do documentos com justificativa.',
                    },
                ]
            }
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap.min.css"></style>
<style scoped>
    a.fa-times {
        color: #ff4d4d;
        text-decoration: none;
        cursor: pointer;
        position: fixed;
        top: 3vw;
        left: 1.5vw;
        z-index: 20;
    }

    [id*='section-'] {
        background-color: #f8f9fa !important;
        font-family: 'Montserrat';
        min-height: 100vh;
        /* z-index: 10; */
    }

    h4 {
        font-size: 32px;
        line-height: 1.1875;
        font-family: "Montserrat";
    }

    #section-functions .card {
        border-radius: 5px;
        /* min-height: 300px; */
        text-align: justify;
        transition: all 0.3s;
        /* background-color: white; */
        background: #667db6;
        background: -webkit-linear-gradient(to right, #667db6aa, #56ccf2aa, #56ccf2aa, #667db6aa);
        background: linear-gradient(to right, #667db6aa, #56ccf2aa, #56ccf2aa, #667db6aa);
        /* border: 0; */
        /* border: 1px solid #888888; */
        box-shadow: 0px 0px 5px 0.2px #888888;
    }

    #section-functions .card:hover {
        border: 0;
        box-shadow: 0px 0px 10px 3px #888888;
        transform: scale(1.01);
    }

    #section-functions .bord {
        padding: 20px;
        align-self: center;
        border: 0;
        border-radius: 50%;
        box-shadow: 0px 0px 15px -5px #88888890;
    }

    #section-functions .card img {
        margin: 0;
    }

    #section-functions .card .titulo {
        font-size: 20px;
        font-weight: 600;
        padding: 5% 0;
        text-align: center;
        /* color: #4464d8; */
    }

    #section-functions .card p {
        font-size: 16px;
        padding: 5% 0;
        font-family: 'Montserrat', sans-serif;
    }

    @media screen and (max-width: 992px) {
        h4 {
            font-size: 22px;
        }
    }
</style>